import classNames from "classnames";
import scss from "@/styles/pages/who-we-are/directors.module.scss";

export const wrapper = (isDark: boolean): string => {
    return classNames(
        // Mobile
        "mobile:p-5",
        "mobile:pt-5",
        "mobile:pb-5",
        // Tablet
        "tablet:p-5",
        "tablet:pt-10",
        "tablet:pb-10",
        // All
        isDark && scss["wrapper"],
        isDark ? "bg-secondary" : "bg-white"
    );
};

export const evenContainer = classNames(
    // Mobile
    "mobile:flex-col",
    "mobile:w-full",
    // Tablet
    "tablet:flex-row",
    // "tablet:w-10/12",

    // All
    "flex",
    "items-center",
    "justify-center",
    "flex-wrap",
    "mt-8",
    // "mb-5",
    "max-w-[1600px]",
    "m-auto"
    
);

export const oddContainer = classNames(
    // Mobile
    "mobile:flex-col",
    // Tablet
    "tablet:flex-row",
    // All
    "flex",
    "items-center",
    "justify-evenly",
    "flex-wrap",
    "mt-10",
    "mb-5",
    "max-w-[1600px]",
    "m-auto"
);
